import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import { PublicApiConfigDto } from './vive-api-models';

class CompaniesPublicApiService extends ViveApiBaseService {
  public async findAllPublicApiAccessKey(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<PublicApiConfigDto[]> {
    const { options, pathParams } = params;
    return await this.sendGet<PublicApiConfigDto[]>({
      apiEndpoint: 'companies/:companyId/public-api/api-access-key',
      options,
      pathParams
    });
  }

  public async createPublicApiAccessKey(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<PublicApiConfigDto> {
    const { options, pathParams } = params;
    return await this.sendPost<PublicApiConfigDto>({
      apiEndpoint: 'companies/:companyId/public-api/api-access-key',
      options,
      pathParams
    });
  }

  public async deletePublicApiAccessKey(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number; apiAccessKey: string };
  }): Promise<void> {
    const { options, pathParams } = params;
    return await this.sendDelete<void>({
      apiEndpoint:
        'companies/:companyId/public-api/api-access-key/:apiAccessKey',
      options,
      pathParams
    });
  }
}

export const companiesPublicApiService = new CompaniesPublicApiService();
